export class UniversityProfessionCardModel {
  id: string = ''
  background: string = ''
  profession: string = ''
  image: string = ''
  name: string = ''
  description: string = ''
  score: string = ''
  price: string = ''
  slug?: string = ''
}
